// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__hhuJf","footer":"ModalCreateQualiphyProcedure_footer__3DKyZ","additionData":"ModalCreateQualiphyProcedure_additionData__3RH9b"};